module.exports = require("base64-js");


//////////////////
// WEBPACK FOOTER
// external "base64-js"
// module id = 518
// module chunks = 0